import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const NotFoundPage = () => {
  return (
    <div id="notFoundPage">
      <div id="notFoundPage__container">
        <h2>Page introuvable</h2>
        <p>
          Il semble que vous ayez suivi un lien rompu ou entré une URL qui
          n'existe pas sur ce site.
        </p>
        <hr />
        <Link id="backHome" to="/#">
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{ fontSize: "1.2rem", marginRight: ".7rem" }}
          />
          Revenir vers l'accueil de Carte Verte
        </Link>
      </div>
    </div>
  );
};

export { NotFoundPage as default };
